/* Gamers Point customer-facing features. No checkout customization, app or inventory mutation. */
(function(){
 'use strict';
 const root=(window.Shopify && Shopify.routes && Shopify.routes.root)||'/';
 const safeText=v=>String(v==null?'':v);
 const qs=(s,el=document)=>el.querySelector(s);
 const qsa=(s,el=document)=>[...el.querySelectorAll(s)];
 const button=(text,klass)=>{const b=document.createElement('button');b.type='button';b.textContent=text;b.className=klass||'';return b};
 function money(amount){
  if(window.GPCurrency&&typeof window.GPCurrency.formatFromMinor==='function'){
   return window.GPCurrency.formatFromMinor(amount);
  }
  return 'BHD '+(Number(amount||0)/100).toFixed(3);
 }
 function whatsapp(message){return 'https://wa.me/97336820393?text='+encodeURIComponent(message)}
 function readCompare(){try{const a=JSON.parse(localStorage.getItem('gp_compare_products')||'[]');return Array.isArray(a)?a.slice(0,3):[]}catch(e){return []}}
 function saveCompare(v){try{localStorage.setItem('gp_compare_products',JSON.stringify(v))}catch(e){}updateCompare()}
 function updateCompare(){
  const tray=qs('[data-gp-compare-tray]');if(!tray)return;
  const items=readCompare();tray.hidden=!items.length;
  const n=qs('[data-gp-compare-count]',tray);if(n)n.textContent=items.length;
  qsa('[data-gp-compare-add]').forEach(b=>{b.textContent=items.some(i=>i.id===b.dataset.id)?'Remove from compare':'Add to compare'});
 }
 function compareInit(){
  qsa('[data-gp-compare-add]').forEach(b=>b.addEventListener('click',()=>{
   const arr=readCompare(),id=b.dataset.id,idx=arr.findIndex(i=>i.id===id);
   if(idx>=0)arr.splice(idx,1);else if(arr.length<3)arr.push({id,title:b.dataset.title,url:b.dataset.url,price:b.dataset.price,type:b.dataset.type,brand:b.dataset.brand,image:b.dataset.image,available:b.dataset.available==='true'});
   else{alert('Compare up to 3 products at a time.');return}
   saveCompare(arr);
  }));
  const modal=qs('[data-gp-compare-dialog]');
  const open=qs('[data-gp-compare-open]');
  const close=()=>{if(modal){modal.hidden=true;document.body.style.overflow=''}};
  if(open)open.addEventListener('click',()=>{
   const grid=qs('[data-gp-compare-grid]');if(!grid||!modal)return;grid.replaceChildren();
   for(const i of readCompare()){
    const div=document.createElement('article');div.className='gp-compare-item';
    if(i.image&&i.image.startsWith('https://')){const img=document.createElement('img');img.src=i.image;img.alt='';div.append(img)}
    const h=document.createElement('a');h.textContent=i.title;h.href=i.url;div.append(h);
    const dl=document.createElement('dl');
    for(const pair of [['Listed price',i.price],['Category',i.type||'Not listed'],['Brand',i.brand||'Not listed'],['Availability',i.available?'Listed available':'Request availability']]){
     const dt=document.createElement('dt');dt.textContent=pair[0];const dd=document.createElement('dd');dd.textContent=pair[1];dl.append(dt,dd)
    }div.append(dl);grid.append(div);
   }
   modal.hidden=false;document.body.style.overflow='hidden';
   qs('[data-gp-compare-close]',modal)?.focus();
  });
  qs('[data-gp-compare-close]')?.addEventListener('click',close);
  modal?.addEventListener('click',e=>{if(e.target===modal)close()});
  document.addEventListener('keydown',e=>{if(e.key==='Escape')close()});
  qs('[data-gp-compare-clear]')?.addEventListener('click',()=>saveCompare([]));
  updateCompare();
 }
 function productInit(){
  const el=qs('[data-gp-feature-product]');if(!el)return;
  qs('[data-gp-wa-product]',el)?.addEventListener('click',e=>{
   const link=e.currentTarget;
   const variant=qs('form[action*="/cart/add"] [name="id"]')?.value||el.dataset.variant||'';
   const text='Hello Gamers Point, I am interested in '+safeText(link.dataset.productTitle)+'. Variant ID: '+variant+'. Product: '+location.origin+location.pathname+'. Please confirm availability, final price and delivery time.';
   link.href=whatsapp(text);
  });
  const reg=qs('[data-gp-region-check]',el);if(!reg)return;
  const select=qs('#gp-region-select',reg),result=qs('.gp-region-result',reg);
  select?.addEventListener('change',()=>{
   const val=select.value.toUpperCase(),listed=safeText(reg.dataset.listedRegion).toUpperCase();
   if(!val){result.textContent='Choose a region to see guidance. This is not an activation guarantee.';result.dataset.state='';return}
   const us=listed.includes('USA')||listed.includes('(US)')||listed==='US',uk=listed==='UK'||listed.includes('UNITED KINGDOM');
   const mismatch=(us&&val!=='US')||(uk&&val!=='UK');
   const match=(us&&val==='US')||(uk&&val==='UK');
   result.dataset.state=mismatch?'warning':match?'match':'';
   result.textContent=mismatch?'Possible region mismatch. Please ask Gamers Point before ordering.':match?'Your selected region appears to match the listing; confirm account and redemption eligibility before purchase.':'Automatic compatibility cannot be confirmed for this product. Verify its redemption terms with Gamers Point.';
  });
 }
 function searchInit(){
  const input=qs('#gp-ref-search-input');
  const form=input?.closest('form');
  if(!input||!form)return;
  input.setAttribute('autocomplete','off');
  input.setAttribute('role','combobox');
  input.setAttribute('aria-autocomplete','list');
  let selected=-1,lastResults='',seq=0,controller=null,timer=0,links=[];
  const storageKey='gp_search_recent_v2';
  const dropdown=document.createElement('div');
  dropdown.className='gp-search-suggest gp-search-next';
  dropdown.hidden=true;
  dropdown.id='gp-live-results';
  dropdown.setAttribute('role','listbox');
  dropdown.setAttribute('aria-label','Gamers Point search results');
  input.setAttribute('aria-controls',dropdown.id);
  input.setAttribute('aria-expanded','false');
  form.append(dropdown);
  const searchUrl=q=>root+'search?q='+encodeURIComponent(q)+'&type=product';
  const recent=()=>{try{return JSON.parse(localStorage.getItem(storageKey)||'[]').filter(x=>typeof x==='string').slice(0,5)}catch(e){return []}};
  const persist=q=>{q=q.trim().slice(0,90);if(!q)return;try{localStorage.setItem(storageKey,JSON.stringify([q,...recent().filter(x=>x.toLowerCase()!==q.toLowerCase())].slice(0,5)))}catch(e){}};
  const shown=(value)=>{dropdown.hidden=!value;input.setAttribute('aria-expanded',String(value));input.setAttribute('aria-activedescendant',value&&links[selected]?links[selected].id:'')};
  const close=()=>{shown(false);selected=-1;links=[]};
  const section=(title)=>{
   const h=document.createElement('div');h.className='gp-search-next__heading';h.textContent=title;dropdown.append(h);
  };
  const makeLink=(text,href,detail,imageUrl)=>{
   const a=document.createElement('a');
   a.href=href;
   a.className='gp-suggestion-item gp-search-next__link';
   a.setAttribute('role','option');
   a.id='gp-search-opt-'+links.length;
   if(imageUrl&&/^https?:\/\//i.test(imageUrl)){
    const img=document.createElement('img');img.src=imageUrl;img.alt='';img.loading='lazy';a.append(img);
   }
   const words=document.createElement('span');words.textContent=text;
   if(detail){const small=document.createElement('small');small.textContent=detail;words.append(small)}
   a.append(words);dropdown.append(a);
   links.push(a);
   return a;
  };
  const showCategories=()=>{
   dropdown.replaceChildren();links=[];selected=-1;
   if(recent().length){
    section('Recent searches');
    for(const query of recent())makeLink(query,searchUrl(query),'Repeat this search');
    const clear=document.createElement('button');clear.type='button';clear.className='gp-search-next__clear';clear.textContent='Clear recent searches';
    clear.addEventListener('click',()=>{try{localStorage.removeItem(storageKey)}catch(e){};showCategories()});
    dropdown.append(clear);
   }
   section('Popular categories');
   const categories=[
    ['Steam Wallet','/collections/steam-wallet'],
    ['PlayStation Cards','/collections/psn-bahrain'],
    ['Gaming PCs','/collections/ready-pc-builds'],
    ['Graphics Cards','/collections/gpu-graphic-cards'],
    ['Monitors','/collections/monitor']
   ];
   categories.forEach(([name,url])=>makeLink(name,url,'Shop category'));
   shown(true);
  };
  const renderResults=(data,q)=>{
   dropdown.replaceChildren();selected=-1;links=[];
   const results=data.resources?.results||{};
   const products=results.products||[];
   const collections=results.collections||[];
   const queries=results.queries||[];
   if(products.length){
    section('Products');
    for(const item of products.slice(0,5)){
     let detail=(item.vendor?item.vendor+' · ':'')+(item.price!=null?money(item.price):'');
     if(item.available===false)detail+=' · Availability enquiry';
     makeLink(item.title,item.url||searchUrl(q),detail,item.featured_image?.url||item.image);
    }
   }
   if(collections.length){
    section('Collections');
    for(const item of collections.slice(0,3))makeLink(item.title,item.url||'/collections','Explore collection');
   }
   if(queries.length){
    section('Suggested searches');
    for(const item of queries.slice(0,3)){
     const term=String(item.text||item.query||'').trim();
     if(term)makeLink(term,searchUrl(term),'Search suggestion');
    }
   }
   if(!links.length){
    const msg=document.createElement('p');msg.className='gp-search-next__empty';msg.textContent='No instant matches. Press Enter to search the full catalog.';dropdown.append(msg);
   }
   const footer=document.createElement('a');footer.className='gp-suggestion-item gp-search-next__footer';footer.href=searchUrl(q);footer.textContent='View all results for “'+q.slice(0,80)+'” →';dropdown.append(footer);links.push(footer);
   shown(true);
  };
  const requestResults=()=>{
   const q=input.value.trim();const ticket=++seq;clearTimeout(timer);
   controller?.abort();controller=null;
   if(q.length<2){if(document.activeElement===input)showCategories();else close();return}
   timer=setTimeout(async()=>{
    try{
     controller=new AbortController();
     const endpoint=root+'search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product,collection,query&resources[limit]=5&resources[options][unavailable_products]=last';
     const res=await fetch(endpoint,{headers:{Accept:'application/json'},signal:controller.signal});
     if(!res.ok)throw new Error('Search returned '+res.status);
     const data=await res.json();if(ticket!==seq||q!==input.value.trim())return;
     renderResults(data,q);
    }catch(e){if(e.name!=='AbortError'){dropdown.replaceChildren();links=[];const fallback=makeLink('Search all products for '+q,searchUrl(q),'Open complete search results');shown(true)}}
   },210);
  };
  input.addEventListener('input',requestResults);
  input.addEventListener('focus',()=>{if(input.value.trim().length<2)showCategories();else requestResults()});
  input.addEventListener('keydown',e=>{
   if(e.key==='Escape'){close();return}
   if(e.key==='ArrowDown'&&!dropdown.hidden&&links.length){
    e.preventDefault();selected=(selected+1)%links.length;links.forEach((a,i)=>a.classList.toggle('is-active',selected===i));input.setAttribute('aria-activedescendant',links[selected].id||'');
   }else if(e.key==='ArrowUp'&&!dropdown.hidden&&links.length){
    e.preventDefault();selected=(selected-1+links.length)%links.length;links.forEach((a,i)=>a.classList.toggle('is-active',selected===i));input.setAttribute('aria-activedescendant',links[selected].id||'');
   }else if(e.key==='Enter'){
    if(!dropdown.hidden&&selected>=0&&links[selected]){e.preventDefault();persist(input.value);location.assign(links[selected].href)}
    else persist(input.value);
   }
  });
  form.addEventListener('submit',()=>persist(input.value));
  dropdown.addEventListener('click',e=>{if(e.target.closest('a'))persist(input.value)});
  document.addEventListener('pointerdown',e=>{if(!form.contains(e.target))close()});
 }
 async function cartSuggestions(){
  const wrap=qs('[data-gp-cart-suggestions]'),grid=qs('[data-gp-suggestion-list]',wrap||document);if(!wrap||!grid)return;
  const pid=wrap.dataset.productId;if(!/^\d+$/.test(pid))return;
  try{
   let res=await fetch(root+'recommendations/products.json?product_id='+encodeURIComponent(pid)+'&limit=4&intent=complementary');
   if(!res.ok)throw new Error('Recommend API');
   let data=await res.json(),items=data.products||[];
   if(!items.length){res=await fetch(root+'recommendations/products.json?product_id='+encodeURIComponent(pid)+'&limit=4');if(res.ok){data=await res.json();items=data.products||[]}}
   for(const p of items.slice(0,4)){
    if(!p.available)continue;
    const card=document.createElement('div');card.className='gp-cart-suggestion';
    if(p.featured_image){const img=document.createElement('img');img.loading='lazy';img.src=p.featured_image;img.alt='';card.append(img)}
    const a=document.createElement('a');a.href=p.url;a.textContent=p.title;card.append(a);
    const price=document.createElement('span');price.textContent=money(p.price);card.append(price);
    const first=(p.variants||[]).find(v=>v.available);
    if(first){const add=button('Add to cart');add.addEventListener('click',async()=>{
      add.disabled=true;add.textContent='Adding...';
      try{const r=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:first.id,quantity:1})});if(!r.ok)throw new Error('Item unavailable');location.reload()}
      catch(e){add.disabled=false;add.textContent='Try again';alert('Could not add item. Please open its product page.')}
    });card.append(add)}
    grid.append(card)
   }
   if(!grid.children.length)wrap.hidden=true;
  }catch(e){wrap.hidden=true}
 }
 document.addEventListener('DOMContentLoaded',()=>{searchInit();productInit();compareInit();cartSuggestions()});
})();